import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserCheck, Users } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Button } from "./ui/button";

export const SaveToCustomerBtn = ({ lead, onDone }) => {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  if (lead.customer_id) {
    return (
      <Button variant="outline" onClick={() => navigate(`/admin/customers/${lead.customer_id}`)} data-testid="ws-open-customer-btn">
        <Users className="w-4 h-4 mr-1" /> Customer Profile
      </Button>
    );
  }
  const save = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/customers/from-lead/${lead.id}`);
      toast.success(r.data.existing ? `Purane customer ${r.data.customer_code} me naya Work joda gaya` : `Naya customer ${r.data.customer_code} ban gaya`);
      onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Save nahi hua"); }
    finally { setBusy(false); }
  };
  return (
    <Button onClick={save} disabled={busy} className="bg-teal-700 hover:bg-teal-800 text-white" data-testid="ws-save-customer-btn">
      <UserCheck className="w-4 h-4 mr-1" /> {busy ? "Saving…" : "Customer Details me Save"}
    </Button>
  );
};
